const userRoles = {
  all: '*',
  employee: 'employee',
};

export default userRoles;
